var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.loading,"absolute":true,"color":"#fff","opacity":1}},[_c('v-progress-circular',{attrs:{"indeterminate":"","value":60,"color":"blue-grey"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }